import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { LOGOS } from "@/lib/utils";
import { translateFr as tfr } from "@/i18n";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id });
        setUser(r.data);
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <img src={LOGOS.white} alt="Athlynx" className="h-10 w-auto dark:block hidden" />
        <img src={LOGOS.black} alt="Athlynx" className="h-10 w-auto dark:hidden" />
        <div className="text-sm text-muted-foreground">{tfr("Connexion en cours…")}</div>
      </div>
    </div>
  );
}
